<template>
  <div id="app">
    <div class="bg"></div>
    <router-view style="position: relative;z-index: 9;" v-if="state" />
  </div>
</template>
<script>
  import { login, getInfo} from "@/api/login";
  export default {
    data() {
      return {
        state: false
      }
    },
    mounted(){
      // this.setTest();
      this.getParam((uuid) => {
        if(uuid){
          this.loginEvent(uuid);
        } else {
          this.closePage();
        };
      });
    },
    methods: {
      setTest() {
        localStorage.setItem("st", "eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImUxNTJlOTgzLWExMTItNGM3Ny1hMmI5LTA1ZWViMzQ5NDVjYSJ9.51t_a46gzGaKj3XWVyvN2CQTDBH-03sY4vxeGWnuF_XIAuU4N_tHGWWCKWP5zBjOPbB-gT2QQ1g8UDgCHXPS5A");
        this.getInfoEvent(() => {
          this.state = true;
        });
      },
      // 截取链接后面的参数
      getParam(callback){
        if(localStorage.getItem("st")){
          this.getInfoEvent(() => {
            this.state = true;
          });
          return;
        };
        const localData = window.location;
        const search = localData.search || localData.hash;
        const str = search.split("?")[1];
        if(!str){
          this.closePage();
          return;
        };
        if(str.indexOf("=") > -1){
          let uuid = str.split("=")[1];
          callback && callback(uuid);
        } else {
          callback && callback(str);
        };
      },
      // 登录
      loginEvent(uuid) {
        login(uuid).then((res) => {
          localStorage.setItem("st", res.data);
          this.getInfoEvent(() => {
            this.state = true;
          });
        });
      },
      // 获取用户信息
      getInfoEvent(callback) {
        getInfo().then((res) => {
          localStorage.setItem("ui", JSON.stringify(res.user));
          callback && callback();
        })
      },
      closePage() {
        localStorage.removeItem("st");
        window.close();
      }
    },
    beforeDestroy() {
      autofit.off();
    }
  }
</script>
<style lang="less">
  #app {
    position: relative;
    width: 100vw;
    height: 100vh;
    background-image: url("./assets/img/page-bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .bg {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
      width: 100%;
      height: 100%;
      background-image: url("./assets/img/bg-jb.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
</style>
